// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedCountry: null
}

const countries = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_COUNTRIES_DROPDOWN':
      return { ...state, dropdown: action.data }
    case 'GET_ALL_COUNTRIES':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_COUNTRIES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_COUNTRY':
      return { ...state, selectedCountry: action.selectedCountry }
    case 'ADD_COUNTRY':
      return { ...state }
    case 'DELETE_COUNTRY':
      return { ...state }
    default:
      return { ...state }
  }
}
export default countries
